import { Box, Button, Flex, Image, Title } from "@mantine/core";
import { IconLayoutSidebarLeftExpand } from "@tabler/icons-react";

import { LogomarkIcon } from "@/shared/assets/icons";
import { HeaderLogoIcon } from "@/shared/assets/images";

import type { HeaderProps } from "./type";

export default function Header({ collapsed, title, onToggle }: HeaderProps) {
  return (
    <Flex align="center" gap="sm">
      <Box w={collapsed ? "70px" : "210px"}>
        <Image src={collapsed ? LogomarkIcon : HeaderLogoIcon} h={40} fit="contain" alt="لوگوی وی‌بوم" />
      </Box>

      <Flex gap="xs" align="center">
        <Button onClick={onToggle} variant="transparent">
          <IconLayoutSidebarLeftExpand size={20} />
        </Button>

        <Title fz="lg">{title}</Title>
      </Flex>
    </Flex>
  );
}
